export { default as HomeSkeleton } from './HomeSkeleton';
export { default as ChatSkeleton } from './ChatSkeleton';
export { default as FAQSkeleton } from './FAQSkeleton';
export { default as WidgetSkeleton } from './WidgetSkeleton';
export { default as SettingSkeleton } from './SettingSkeleton'; 